import React from 'react';
import _get from 'lodash/get';
import PromoBannerAnimate from '../../../components/PromotionalBanner/components/PromoBannerAnimate';

let val = false;
const massageData = (data) => {
    const promoBannerArr = [];
    /* istanbul ignore next */
    const {
        primaryText: promoText = '',
        linkText = '',
        link,
        openInNewTab: targetWindow = false,
        secondaryText = '',
        backgroundColor = '',
    } = data;
    const targetUrl = link && link !== null ? link.url : '';
    let promoBannerObj = {};
    promoBannerObj = {
        promoText,
        linkText,
        targetUrl,
        targetWindow,
        secondaryText,
        backgroundColor,
    };
    promoBannerArr.push(promoBannerObj);
    return promoBannerArr;
};

export default (props) => {
    // eslint-disable-next-line react/prop-types
    const { pageType, deviceType, featureFlags } = props;
    val = !val;
    return (
        <PromoBannerAnimate
            offerDetails={massageData(props)}
            pageType={pageType}
            deviceType={deviceType}
            enableIrisSitePromo={_get(featureFlags, 'enableIrisSitePromo', true)} // this value is passed only to iris intool, not for yoda
            disableSitewideSeoUrl={_get(featureFlags, 'disableSitewideSeoUrl', true)} // this value is passed only to iris intool, not for yoda
        />
    );
};
